import { EligibilityPayload } from "../models/CheckEligibility";
import API from "./api";

export const CheckEligibility = (configUrl: string, payload: EligibilityPayload) => API.postApi(`${configUrl}api/eligibility/Check`, payload)